import React from 'react';
import PropTypes from 'prop-types';

import { Image } from '../Image';
import { Link } from '../Link';
import { Svg } from '../Svg';

export function ThreeTilesTile({ aspectRatio, item, textColor }) {
  return (
    <div className="w-full" style={{ color: textColor }}>
      <div className={`relative mb-4 bg-offWhite ${aspectRatio}`}>
        <Link
          aria-label={item.heading}
          href={item.link?.url}
          newTab={item.link?.newTab}
          tabIndex="-1"
        >
          {item.image?.src && (
            <Image
              alt={item.alt}
              className={`${item.position}`}
              fill
              sizes="(min-width: 1440px) 1200px, (min-width: 768px) 50vw, 100vw"
              src={item.image.src}
            />
          )}
        </Link>
      </div>

      <div className="inset-0 flex h-full w-full flex-col items-start gap-4">
        <Link
          aria-label={item.heading}
          href={item.link?.url}
          newTab={item.link?.newTab}
        >
          <div className="group flex">
            <h2 className="text-xl lg:text-2xl">{item.heading}</h2>

            <span className="ml-[0.75rem] block w-[1.25rem] transition-transform lg:group-hover:translate-x-2">
              <Svg
                src="/svgs/arrow-right.svg#arrow-right"
                title="Arrow"
                viewBox="0 0 24 24"
              />
            </span>
          </div>
        </Link>

        {item.description && <p>{item.description}</p>}

        {item.link?.text && (
          <div>
            <Link
              aria-label={item.link.text}
              className="text-label text-main-underline"
              href={item.link.url}
              newTab={item.link.newTab}
              tabIndex="-1"
            >
              {item.link.text}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}

ThreeTilesTile.displayName = 'ThreeTilesTile';
ThreeTilesTile.propTypes = {
  aspectRatio: PropTypes.string,
  item: PropTypes.object,
  textColor: PropTypes.string,
};
